import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { queryClient } from '@hero/clients';
import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useUpdateTagContacts = options => {
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(({ id, body }) => contactServices.updateTagContacts(id, body), {
    ...options,
    onSuccess: () => {
      showSuccess({
        message: t('tagSuccessfullyUpdated'),
        type: 'toast'
      });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetContactsKey] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetTagListKey] });
    }
  });
};
